import * as React from "react";

function TipJarIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    stroke: "currentColor"
  }, props), /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 7.5,
    x: 6,
    y: 13,
    rx: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 12a1 1 0 011-1h8a1 1 0 011 1v1H7v-1z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 6.5,
    r: 3
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    d: "M12.242 5.53l-.484 1.94"
  }));
}

export default TipJarIcon;